import { UtilsProvider } from "../../providers/utils-provider.service";
import { OrganizationRole } from "../../models/organization-role";

export class HeaderRights {
    public Ready: Promise<boolean> = new Promise<boolean>((resolve, reject) => resolve(false));
    private _screenRightsList: HeaderScreenRightList | null = null;
    private _paramsScreen: HeaderScreenRightsParams | null = null;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }


    public evaluateScreenRights(params: HeaderScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();

        if(!this._screenRightsList) return;

        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.dashboard = true;
            this._screenRightsList.libraries = true;
            this._screenRightsList.teams = true;
            this._screenRightsList.coaches = true;
            this._screenRightsList.athletes = true;
            this._screenRightsList.profile = true;
            this._screenRightsList.organizations = true;
            this._screenRightsList.guests = true;
            this._screenRightsList.chat = false;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.dashboard = true;
            this._screenRightsList.libraries = true;
            this._screenRightsList.teams = true;
            this._screenRightsList.coaches = true;
            this._screenRightsList.athletes = true;
            this._screenRightsList.profile = true;
            this._screenRightsList.organizations = true;
            this._screenRightsList.guests = true;
            this._screenRightsList.chat = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.dashboard = true;
            this._screenRightsList.libraries = true;
            this._screenRightsList.teams = true;
            this._screenRightsList.coaches = false;
            this._screenRightsList.athletes = true;
            this._screenRightsList.profile = true;
            this._screenRightsList.organizations = true;
            this._screenRightsList.guests = true;
            this._screenRightsList.chat = true;
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            this._screenRightsList.dashboard = true;
            this._screenRightsList.libraries = false;
            this._screenRightsList.teams = false;
            this._screenRightsList.coaches = false;
            this._screenRightsList.athletes = false;
            this._screenRightsList.profile = true;
            this._screenRightsList.organizations = true;
            this._screenRightsList.guests = false;
            this._screenRightsList.chat = true;
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.dashboard = true;
            this._screenRightsList.libraries = false;
            this._screenRightsList.teams = true;
            this._screenRightsList.coaches = false;
            this._screenRightsList.athletes = true;
            this._screenRightsList.profile = true;
            this._screenRightsList.organizations = true;
            this._screenRightsList.guests = true;
            this._screenRightsList.chat = false;
            break;

        default:
            // rien
        }
    }

    public getScreenRightsList(): HeaderScreenRightList {
        if (!this._screenRightsList) throw new Error('Screen rights not initialized');
        return this._screenRightsList;
    }

    public getScreenParams(): HeaderScreenRightsParams {
        if (!this._paramsScreen) throw new Error('Screen params not initialized');
        return this._paramsScreen;
    }

    public get DASHBOARD() {
        if (this._screenRightsList) {
            return this._screenRightsList.dashboard;
        }
        return false;
    }

    public get LIBRARIES() {
        if (this._screenRightsList) {
            return this._screenRightsList.libraries;
        }
        return false;
    }

    public get TEAMS() {
        if (this._screenRightsList) {
            return this._screenRightsList.teams;
        }
        return false;
    }

    public get COACHES() {
        if (this._screenRightsList) {
            return this._screenRightsList.coaches;
        }
        return false;
    }

    public get ATHLETES() {
        if (this._screenRightsList) {
            return this._screenRightsList.athletes;
        }
        return false;
    }

    public get GUESTS() {
        if (this._screenRightsList) {
            return this._screenRightsList.guests;
        }
        return false;
    }

    public get CHAT() {
        if (this._screenRightsList) {
            return this._screenRightsList.chat;
        }
        return false;
    }

    public get PROFILE() {
        if (this._screenRightsList) {
            return this._screenRightsList.profile;
        }
        return false;
    }

    public get ORGANIZATIONS() {
        if (this._screenRightsList) {
            return this._screenRightsList.organizations;
        }
        return false;
    }

    private setDefault(): void {

      this._screenRightsList = {
          dashboard: false,
          libraries: false,
          teams: false,
          coaches: false,
          athletes: false,
          profile: false,
          organizations: false,
          guests: false,
          chat: false,
        };
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}

export interface HeaderScreenRightList {
    dashboard: boolean;
    libraries: boolean;
    teams: boolean;
    coaches: boolean;
    athletes: boolean;
    profile: boolean;
    organizations: boolean;
    guests: boolean;
    chat: boolean;
}

export interface HeaderScreenRightsParams {
    rolesIds: number[];
}
